<template>
	<div>
		<h2 class="mb-3">Event Reports</h2>
		<v-form v-model="isValidForm">
			<v-card class="pa-3">
				<v-row class="pb-0">
					<v-col cols="6" class="pb-0">
						<v-select
							v-model="reportTypeSelected"
							:items="reportTypeList"
							color="blue-grey lighten-2"
							label="Select a report type"
							:rules="fieldRules"
							item-text="name"
							item-value="name"
							outlined
						>
							<!-- Template for render data when the select is expanded -->
							<template slot="item" slot-scope="data">
								<!-- Divider and Header-->
								<template v-if="typeof data.item !== 'object'">
									<v-card-title v-text="data.item" />
								</template>
								<!-- Normal item -->
								<template v-else>
									<v-card-text v-html="data.item.name" />
								</template>
							</template>
						</v-select>
					</v-col>
					<v-col cols="6" class="pb-0" v-if="reportTypeSelected != 'Leaderboard report'">
						<v-menu v-model="isShowFrom" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
							<template v-slot:activator="{ on }">
								<v-text-field
									autocapitalize
									v-model="fromDate"
									label="From Date"
									append-icon="mdi-calendar-today"
									:rules="fieldRules"
									v-on="on"
									outlined
									readonly
								></v-text-field>
							</template>
							<v-date-picker v-model="fromDate" @input="isShowFrom = false"></v-date-picker>
						</v-menu>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="6" class="pt-0" v-if="reportTypeSelected != 'Leaderboard report'">
						<v-select
							v-model="selectedBoothId"
							v-if="
								reportTypeSelected == 'Overall booth summary' ||
								reportTypeSelected == 'Document and video summary' ||
								reportTypeSelected == 'Booth banner clicks summary' ||
								reportTypeSelected == 'Content links summary' ||
								reportTypeSelected == 'Booth visitor list'
							"
							label="Select Booth"
							:items="boothList"
							item-text="name"
							item-value="id"
							outlined
						></v-select>

						<v-select
							v-model="selectedStructureId"
							v-if="reportTypeSelected == 'Room banner visited'"
							label="Select Room"
							:items="structureList"
							item-text="name"
							item-value="id"
							outlined
						></v-select>
						<v-select
							v-model="selectedVideoId"
							v-if="reportTypeSelected == 'Presentation video visited'"
							label="Select Video"
							:items="presentationList"
							item-text="title"
							item-value="id"
							outlined
						></v-select>
						<v-select
							v-if="reportTypeSelected == 'Login report' || reportTypeSelected == 'Lobby chat visited'"
							v-model="filter"
							label="Filter Columns By"
							:items="['Date', 'Person']"
							:rules="fieldRules"
							outlined
							solo
						></v-select>
						<v-select
							v-if="reportTypeSelected == 'Briefcase report'"
							v-model="filter"
							label="Filter Columns By"
							:items="['None', 'Date', 'Person']"
							:rules="fieldRules"
							outlined
							solo
						></v-select>

						<v-select
							v-model="selectedUserId"
							v-if="reportTypeSelected == 'User Activity'"
							label="Select User"
							:items="userList"
							item-text="name"
							item-value="id"
							outlined
						></v-select>
					</v-col>

					<v-col cols="6" class="pt-0" v-if="reportTypeSelected != 'Leaderboard report'">
						<v-menu v-model="isShowTo" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
							<template v-slot:activator="{ on }">
								<v-text-field
									autocapitalize
									v-model="toDate"
									label="To Date"
									:rules="fieldRules"
									append-icon="mdi-calendar-today"
									v-on="on"
									outlined
									readonly
								></v-text-field>
							</template>
							<v-date-picker v-model="toDate" @input="isShowTo = false"></v-date-picker>
						</v-menu>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="6" class="pt-0">
						<v-select
							v-if="
								reportTypeSelected == 'Document and video summary' ||
								reportTypeSelected == 'Booth banner clicks summary' ||
								reportTypeSelected == 'Content links summary' ||
								reportTypeSelected == 'Room banner visited'
							"
							v-model="filter"
							label="Filter Columns By"
							:items="['None', 'Date', 'Person']"
							:rules="fieldRules"
							outlined
							solo
						></v-select>
						<v-select
							v-else-if="reportTypeSelected == 'Booth visitor list'"
							v-model="filter"
							label="Filter Columns By"
							:items="['Date', 'Person']"
							:rules="fieldRules"
							outlined
							solo
						></v-select>
					</v-col>
					<v-col cols="6" class="pt-0">
						<v-autocomplete
							v-if="reportTypeSelected != 'Leaderboard report'"
							v-model="timezone"
							:items="timeZones"
							label="Time Zone"
							append-icon="mdi-map-clock"
							outlined
						></v-autocomplete>
					</v-col>
				</v-row>

				<!---Generate all still not working-->
				<v-row>
					<v-col cols="12">
						<v-btn :disabled="!isValidForm" @click="generateReport()" color="primary" class="mr-3 mt-3 mb-3">Generate Report</v-btn>
						<v-btn
							:disabled="!isValidForm"
							@click="generateAll()"
							color="primary"
							class="ma-3"
							v-if="
								reportTypeSelected == 'Overall booth summary' ||
								reportTypeSelected == 'Booth visitor list' ||
								reportTypeSelected == 'Document and video summary' ||
								reportTypeSelected == 'Booth banner clicks summary' ||
								reportTypeSelected == 'Content links summary' ||
								reportTypeSelected == 'Presentation video visited' ||
								reportTypeSelected == 'Room banner visited' ||
								reportTypeSelected == 'User Activity'
							"
						>Generate All</v-btn>
						<v-btn
								:disabled="!isValidForm"
								@click="generateAllInOnePage()"
								color="primary"
								class="ma-3"
								v-if="reportTypeSelected == 'User Activity'"
						>Generate All In One Page</v-btn>
					</v-col>
				</v-row>
			</v-card>
		</v-form>
	</div>
</template>

<script>
import axios from "axios";

export default {
	props: ["experienceId"],
	data() {
		return {
			fromDate: "",
			toDate: "",
			reportTypeList: [],
			reportTypeSelected: "",
			isShowFrom: false,
			isShowTo: false,
			filter: "",
			boothList: [],
			userList:[],
			selectedBoothId: "",
			liveVideoList: [],
			nonliveVideoList: [],
			presentationList: [],
			selectedVideoId: "",
			structureList: [],
			selectedStructureId: "",
			fieldRules: [v => (!!v && /.*[^ ].*/.test(v)) || "This field is required!"],
			isValidForm: false,
			graphLabels: [" ", " "],
			graphValue: {},
			graphValues: [{ data: [0, 0] }],
			isGenerate: false,
			popper: null,
			tooltipData: null,
			popperIsActive: false,
			experience: {},
			timezone: "",
			timeZones: []
		};
	},
	mounted() {
		this.getReportTypeList();
		this.getBoothList();
		this.getPresentationList();
		this.getStructureList();
		this.listTimeZone();
		this.getUserList();
	},
	methods: {
		getReportTypeList() {
			this.reportTypeList = [
				{
					header: "Experience summary"
				},
				{
					name: "Overall stat summary of attendees from the event",
					group: "Experience summary"
				},
				{
					name: "Login report",
					group: "Experience summary"
				},
				{
					name: "Briefcase report",
					group: "Experience summary"
				},
				{
					name: "Leaderboard report",
					group: "Experience summary"
				},
				{
					name: "User Activity",
					group: "Experience summary"
				},
				{ divider: true },
				{
					header: "Booth summary"
				},
				{
					name: "Overall booth summary",
					group: "Booth summary"
				},
				{
					name: "Booth visitor list",
					group: "Booth summary"
				},
				{
					name: "Document and video summary",
					group: "Booth summary"
				},
				{
					name: "Booth banner clicks summary",
					group: "Booth summary"
				},
				{
					name: "Content links summary",
					group: "Booth summary"
				},
				{ divider: true },
				{
					header: "Chat"
				},
				{
					name: "Lobby chat visited",
					group: "Chat"
				},
				{ divider: true },
				{
					header: "Video"
				},
				{
					name: "Presentation video visited",
					group: "Video"
				},
				{
					name: "Live Presentation Unique Visit",
					group: "Video"
				},
				{
					name: "Room banner visited",
					group: "Video"
				}
			];
		},
		listTimeZone() {
			axios
				.get("/system/enumeration/timezone/list")
				.then(response => {
					this.timeZones = response.data;
				})
				.catch(() => {});
		},
		generateReport() {
			while (this.graphValues.length > 0) {
				this.graphValues.pop();
			}
			if (this.reportTypeSelected == "Login report") {
				location.href =
					axios.defaults.baseURL +
					"/system/report/login?fromDate=" +
					this.fromDate +
					"&toDate=" +
					this.toDate +
					"&experienceId=" +
					this.experienceId +
					"&filter=" +
					this.filter +
					"&timezone=" +
					this.timezone.replace("/", "-");
			} else if (this.reportTypeSelected == "Briefcase report") {
				location.href =
					axios.defaults.baseURL +
					"/system/report/briefcase?fromDate=" +
					this.fromDate +
					"&toDate=" +
					this.toDate +
					"&experienceId=" +
					this.experienceId +
					"&filter=" +
					this.filter +
					"&timezone=" +
					this.timezone.replace("/", "-");
			} else if (this.reportTypeSelected == "Overall stat summary of attendees from the event") {
				location.href =
					axios.defaults.baseURL +
					"/system/report/eventattendees?fromDate=" +
					this.fromDate +
					"&toDate=" +
					this.toDate +
					"&experienceId=" +
					this.experienceId +
					"&timezone=" +
					this.timezone.replace("/", "-");
			} else if (this.reportTypeSelected == "Leaderboard report") {
				location.href = axios.defaults.baseURL + "/system/report/leaderboard?experienceId=" + this.experienceId;
			} else if (this.reportTypeSelected == "User Activity") {
				this.selectedUserId = this.selectedUserId ? this.selectedUserId : null;
				location.href =
					axios.defaults.baseURL +
					"/system/report/userActivity?experienceUserId=" +
					this.selectedUserId +
					"&fromDate=" +
					this.fromDate +
					"&toDate=" +
					this.toDate +
					"&timezone=" +
					this.timezone.replace("/", "-");
			} else if (this.reportTypeSelected == "Overall booth summary") {
				location.href =
					axios.defaults.baseURL +
					"/system/report/overralbooth?boothId=" +
					this.selectedBoothId +
					"&fromDate=" +
					this.fromDate +
					"&toDate=" +
					this.toDate +
					"&experienceId=" +
					this.experienceId +
					"&timezone=" +
					this.timezone.replace("/", "-");
			} else if (this.reportTypeSelected == "Booth visitor list") {
				location.href =
					axios.defaults.baseURL +
					"/system/report/boothvisitor?fromDate=" +
					this.fromDate +
					"&toDate=" +
					this.toDate +
					"&experienceId=" +
					this.experienceId +
					"&filter=" +
					this.filter +
					"&boothId=" +
					this.selectedBoothId +
					"&timezone=" +
					this.timezone.replace("/", "-");
			} else if (this.reportTypeSelected == "Document and video summary") {
				location.href =
					axios.defaults.baseURL +
					"/system/report/document?fromDate=" +
					this.fromDate +
					"&toDate=" +
					this.toDate +
					"&experienceId=" +
					this.experienceId +
					"&filter=" +
					this.filter +
					"&boothId=" +
					this.selectedBoothId +
					"&timezone=" +
					this.timezone.replace("/", "-");
			} else if (this.reportTypeSelected == "Booth banner clicks summary") {
				location.href =
					axios.defaults.baseURL +
					"/system/report/banner?fromDate=" +
					this.fromDate +
					"&toDate=" +
					this.toDate +
					"&experienceId=" +
					this.experienceId +
					"&filter=" +
					this.filter +
					"&boothId=" +
					this.selectedBoothId +
					"&timezone=" +
					this.timezone.replace("/", "-");
			} else if (this.reportTypeSelected == "Content links summary") {
				location.href =
					axios.defaults.baseURL +
					"/system/report/tab?fromDate=" +
					this.fromDate +
					"&toDate=" +
					this.toDate +
					"&experienceId=" +
					this.experienceId +
					"&filter=" +
					this.filter +
					"&boothId=" +
					this.selectedBoothId +
					"&timezone=" +
					this.timezone.replace("/", "-");
			} else if (this.reportTypeSelected == "Lobby chat visited") {
				location.href =
					axios.defaults.baseURL +
					"/system/report/clickchat?fromDate=" +
					this.fromDate +
					"&toDate=" +
					this.toDate +
					"&experienceId=" +
					this.experienceId +
					"&filter=" +
					this.filter +
					"&timezone=" +
					this.timezone.replace("/", "-");
			} else if (this.reportTypeSelected == "Presentation video visited") {
				location.href =
					axios.defaults.baseURL +
					"/system/report/presentationvideo?fromDate=" +
					this.fromDate +
					"&toDate=" +
					this.toDate +
					"&experienceId=" +
					this.experienceId +
					"&presentationId=" +
					this.selectedVideoId +
					"&timezone=" +
					this.timezone.replace("/", "-");
			} else if (this.reportTypeSelected == "Live Presentation Unique Visit") {
				location.href =
					axios.defaults.baseURL +
					"/system/report/livePresentationUniqueVisit?fromDate=" +
					this.fromDate +
					"&toDate=" +
					this.toDate +
					"&experienceId=" +
					this.experienceId +
					"&timezone=" +
					this.timezone.replace("/", "-");
			} else if (this.reportTypeSelected == "Room banner visited") {
				location.href =
					axios.defaults.baseURL +
					"/system/report/structurevideo?fromDate=" +
					this.fromDate +
					"&toDate=" +
					this.toDate +
					"&experienceId=" +
					this.experienceId +
					"&filter=" +
					this.filter +
					"&structureId=" +
					this.selectedStructureId +
					"&timezone=" +
					this.timezone.replace("/", "-");
			} else {
				console.log(this.reportTypeSelected);
			}
		},
		generateAllInOnePage() {					
			axios.get(axios.defaults.baseURL +
					"/system/report/generateAllInOnePage?fromDate=" +
					this.fromDate +
					"&toDate=" +
					this.toDate +
					"&timezone=" +
					this.timezone.replace("/", "-") +
					"&experienceId=" +
					this.experienceId, 
					{responseType: "blob"}
			).then((response) => {
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', "User Activity - "  + new Date().toJSON().slice(0, 10) + ".csv"); //or any other extension
				document.body.appendChild(link);
				link.click();
			});
		},
		generateAll() {
            let params = {};
            let filename = "";

            if (this.reportTypeSelected == "Overall booth summary") {
                params = {
                    idList: this.getListId(this.boothList),
                    fromDate: this.fromDate,
                    toDate: this.toDate,
                    timezone: this.timezone.replace("/", "-"),
                    experienceId: this.experienceId,
                    type: "overall_booth_summary"
                } 
                filename = "Overall Summary - " + new Date().toJSON().slice(0, 10) + ".zip"
            } else if (this.reportTypeSelected == "User Activity") {
                params = {
                    idList: this.getListId(this.userList),
                    fromDate: this.fromDate,
                    toDate: this.toDate,
                    timezone: this.timezone.replace("/", "-"),
                    type: "user_activity"
                }
                filename = "User Activity - "  + new Date().toJSON().slice(0, 10) + ".zip"
            } else if (this.reportTypeSelected == "Booth visitor list") {
                params = {
                    idList: this.getListId(this.boothList),
                    fromDate: this.fromDate,
                    toDate: this.toDate,
                    timezone: this.timezone.replace("/", "-"),
                    experienceId: this.experienceId,
                    filter: this.filter,
                    type: "booth_visitor_list"
                }
                filename = "Booth Visitor List - "  + new Date().toJSON().slice(0, 10) + ".zip"
            } else if (this.reportTypeSelected == "Document and video summary") {
                params = {
                    idList: this.getListId(this.boothList),
                    fromDate: this.fromDate,
                    toDate: this.toDate,
                    timezone: this.timezone.replace("/", "-"),
                    experienceId: this.experienceId,
                    filter: this.filter,
                    type: "document_and_video_summary"
                }
                filename = "Document and Video Summary - "  + new Date().toJSON().slice(0, 10) + ".zip"
            } else if (this.reportTypeSelected == "Booth banner clicks summary") {
                params = {
                    idList: this.getListId(this.boothList),
                    fromDate: this.fromDate,
                    toDate: this.toDate,
                    timezone: this.timezone.replace("/", "-"),
                    experienceId: this.experienceId,
                    filter: this.filter,
                    type: "booth_banner_clicks_summary"
                }
                filename = "Booth Banner Clicks Summary - "  + new Date().toJSON().slice(0, 10) + ".zip"
            } else if (this.reportTypeSelected == "Content links summary") {
                params = {
                    idList: this.getListId(this.boothList),
                    fromDate: this.fromDate,
                    toDate: this.toDate,
                    timezone: this.timezone.replace("/", "-"),
                    experienceId: this.experienceId,
                    filter: this.filter,
                    type: "content_links_summary"
                }
                filename = "Booth Content Links Summary - "  + new Date().toJSON().slice(0, 10) + ".zip"
            } else if (this.reportTypeSelected == "Presentation video visited") {
                params = {
                    idList: this.getListId(this.presentationList),
                    fromDate: this.fromDate,
                    toDate: this.toDate,
                    timezone: this.timezone.replace("/", "-"),
                    experienceId: this.experienceId,
                    type: "presentation_video_visited"
                }
                filename = "Presentation - "  + new Date().toJSON().slice(0, 10) + ".zip"
            } else if (this.reportTypeSelected == "Room banner visited") {
                params = {
                    idList: this.getListId(this.structureList),
                    fromDate: this.fromDate,
                    toDate: this.toDate,
                    timezone: this.timezone.replace("/", "-"),
                    experienceId: this.experienceId,
                    filter: this.filter,
                    type: "room_banner_visited"
                }
                filename = "Room Banner - "  + new Date().toJSON().slice(0, 10) + ".zip"
            }

            axios.post("/system/report/generateAll",params).then((response) => {
                const url = 'data:text/plain;base64,' + response.data;
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", filename);
                document.body.appendChild(link);
                link.click();
            });
        },
		getBoothList() {
			axios
				.post("/system/booth/list", { experienceId: this.experienceId })
				.then(response => {
					this.boothList = response.data;
				})
				.catch();
		},
		getPresentationList() {
			this.presentationList = [];
			axios
				.post("/system/presentation/all/list", { experienceId: this.experienceId })
				.then(response => {
					this.presentationList = response.data;
				})
				.catch();
		},
		getStructureList() {
			axios
				.post("/system/structure/list", { experienceId: this.experienceId })
				.then(response => {
					this.structureList = response.data;
				})
				.catch();
		},
		getUserList() {
			axios
				.post("/system/user/experience/list", { experienceId: this.experienceId })
				.then(response => {
					this.userList = response.data;
					for (let user of this.userList) {
						user.name = user.firstName + " " + user.lastName;
					}
				})
				.catch();
		},
		getListId(list) {
			let result = [];
			for (let item of list) {
				result.push(item.id);
			}
			return result;
		}
	}
};
</script>
